import React from 'react';

import { Typography, useMediaQuery } from 'fronton-react';
import { styled } from 'linaria/react';
import { breakpoints } from 'media';

const ListContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	height: 100%;
`;

const StyledLi = styled.li`
	position: relative;
	padding-left: 13px;
	list-style: none;
	&::before {
		content: '•';
		position: absolute;
		left: -10px;
		top: 0.5em;
		transform: translateY(-50%);
		font-size: 1.5em;
	}
`;

const StyledUL = styled.ul`
	padding-left: 26px;
	margin: 0;
	${breakpoints.only.mobile} {
		font-size: 14px;
	}
`;

export const ListBlock = ({ list, title }: { list: string[]; title: string }) => {
	const isMobile = useMediaQuery('(max-width: 767px)');
	return (
		<ListContainer>
			<Typography size="subtitle" variant={isMobile ? 'm' : 'l'}>
				{title}
			</Typography>
			<StyledUL>
				{list.map(el => (
					<StyledLi key={el}>
						<Typography size="body_long" variant={isMobile ? 'm' : 'l'} as="span">
							{el}
						</Typography>
					</StyledLi>
				))}
			</StyledUL>
		</ListContainer>
	);
};
